import React from "react";
import cl from "classnames";
import { Link } from "react-router-dom";

export default function LessonTab({ tab }) {
  return (
    <div
      className={cl("lesson_tab overflow-auto x-h-md-100", {
        active: tab === "lesson",
      })}
    >
      <div className="lesson_body">
        <ul className="lesson_breadcrumbs">
          <li className="lesson_breadcrumbs_item">
            <Link to="#">
              <span className="bi bi-house text-muted"></span>
            </Link>
          </li>
          <li className="lesson_breadcrumbs_item">
            <Link to="#">
              <span>Clojure</span>
            </Link>
          </li>
          <li className="lesson_breadcrumbs_item">
            <Link to="#">
              <span>Сокращенный синтаксис создания функции 10/43</span>
            </Link>
          </li>
        </ul>
        <div className="lesson_alert alert-info">
          Бесплатный курс по clojure.{" "}
          <Link to="#" className="blue_link" target="_blank">
            Зарегистрируйтесь
          </Link>{" "}
          для отслеживания прогресса →
        </div>
        <div className="lesson_article">
          <h1 className="h3 font-weight-bold">
            Clojure: Сокращенный синтаксис создания функции
          </h1>
          <p>
            Создание функций - настолько частая операция, что в Clojure была
            добавлена сокращенная версия определения (с одновременным
            объявлением) функции с помощью <code>defn</code>. Возьмем для
            примера определение функции возведения в квадрат:
          </p>
          <pre>
            <code className="prettyprint lang-clojure hljs language-clojure">
              (<span className="hljs-keyword">def</span>{" "}
              <span className="hljs-title">square</span> (
              <span className="hljs-name">
                <span className="hljs-built_in">fn</span>
              </span>{" "}
              [n](
              <span className="hljs-name">
                <span className="hljs-built_in">*</span>{" "}
              </span>
              n n)))
            </code>
          </pre>
          <p>А теперь посмотрим сокращенную версию этого же определения:</p>
          <pre>
            <code className="prettyprint lang-clojure hljs language-clojure">
              (<span className="hljs-keyword">def</span>{" "}
              <span className="hljs-title">square</span> (
              <span className="hljs-name">
                <span className="hljs-built_in">fn</span>
              </span>{" "}
              [n](
              <span className="hljs-name">
                <span className="hljs-built_in">*</span>{" "}
              </span>
              n n)))
            </code>
          </pre>
          <p>
            Первое что бросается в глаза — отсутствие слова
            <code>fn</code>. Вместо него, после
            <code>defn</code> указывается имя функции, после имени - список
            параметров. Затем идет тело функции. Объявленная выше функция
            возведения в квадрат принимает один аргумент —<code>n</code>. Пример
            объявления функции с двумя аргументами:
          </p>
          <pre>
            <code className="prettyprint lang-clojure hljs language-clojure">
              (<span className="hljs-keyword">def</span>{" "}
              <span className="hljs-title">square</span> (
              <span className="hljs-name">
                <span className="hljs-built_in">fn</span>
              </span>{" "}
              [n](
              <span className="hljs-name">
                <span className="hljs-built_in">*</span>{" "}
              </span>
              n n)))
            </code>
          </pre>
          <p>
            Помимо определения сигнатуры функции, мы можем тут же использовать
            деструктуризацию (destructuring). Пример функции суммирования, в
            которую передается массив из двух элементов:
          </p>
          <pre>
            <code className="prettyprint lang-clojure hljs language-clojure">
              (<span className="hljs-keyword">def</span>{" "}
              <span className="hljs-title">square</span> (
              <span className="hljs-name">
                <span className="hljs-built_in">fn</span>
              </span>{" "}
              [n](
              <span className="hljs-name">
                <span className="hljs-built_in">*</span>{" "}
              </span>
              n n)))
            </code>
          </pre>
          <h2 className="h4 font-weight-bold">Задание</h2>
          <p>
            Создайте функцию с именем
            <code>sum-of-squares</code> (используя короткий синтаксис), которая
            находит сумму квадратов двух чисел.
          </p>
          <pre>
            <code className="prettyprint lang-clojure hljs language-clojure">
              (<span className="hljs-keyword">def</span>{" "}
              <span className="hljs-title">square</span> (
              <span className="hljs-name">
                <span className="hljs-built_in">fn</span>
              </span>{" "}
              [n](
              <span className="hljs-name">
                <span className="hljs-built_in">*</span>{" "}
              </span>
              n n)))
            </code>
          </pre>
        </div>
        <div className="lesson_gallery row">
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp"
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Boat on Calm Water"
            />

            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain1.webp"
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Wintry Mountain Landscape"
            />
          </div>

          <div className="col-lg-4 mb-4 mb-lg-0">
            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain2.webp"
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Mountains in the Clouds"
            />

            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(73).webp"
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Boat on Calm Water"
            />
          </div>

          <div className="col-lg-4 mb-4 mb-lg-0">
            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/Horizontal/Nature/4-col/img%20(18).webp"
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Waves at Sea"
            />

            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/Vertical/mountain3.webp"
              className="w-100 shadow-1-strong rounded mb-4"
              alt="Yosemite National Park"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
